import { render, staticRenderFns } from "./WsFlex.vue?vue&type=template&id=45a824a6"
import script from "./WsFlex.vue?vue&type=script&lang=js"
export * from "./WsFlex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports